"use client";

import { ForgotPasswordForm } from "@/components/forms/authentication/ForgotPasswordForm";
import { PageViewTracker } from "@/components/observability/PageViewTracker";
import { forgotPasswordAction } from "@/lib/actions/auth";
import { EventKeys } from "@/lib/observability/catalog";

export default function ForgotPasswordPage() {
  return (
    <div className="bg-default-50">
      <div className="w-full max-w-lg mx-auto py-16 px-4 sm:px-0">
        <PageViewTracker
          data={{ section: "forgot-password" }}
          eventKey={EventKeys.PUBLIC_FORGOT_PASSWORD_PAGE_VIEW}
        />
        <div className="w-full max-w-md">
          <ForgotPasswordForm forgotPassword={forgotPasswordAction} />
        </div>
      </div>
    </div>
  );
}
